// @ts-nocheck fa2304a0
import * as selectors from './domainSelectors';

export { selectors };
